// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__JRMXl","container":"Avatar_container__eaDz5","link":"Avatar_link___xp5t"};